import { createApp } from 'vue'
import { loadTranslations } from '@/js/global/vue-i18n'
import Principles from '@/components/articles/Principles.vue'

const app = createApp(Principles)

loadTranslations(app).then(() => {
    app.mount('#principles-vue')
})
